import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { refreshAccessToken } from "../services/api";

const SOCKET_URL = "https://medidores-app-production.up.railway.app";

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [chatUnread, setChatUnread] = useState(0);
  const socketRef = useRef(null);
  const refreshingRef = useRef(false);

  useEffect(() => {
    const tok = localStorage.getItem("token");
    if (!tok) return;

    const s = io(SOCKET_URL, {
      auth: { token: tok },
      transports: ["websocket"],
      reconnection: true,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
    });

    socketRef.current = s;
    setSocket(s);

    s.on("chat:unread_update", (count) => setChatUnread(count));

    // Cuando el socket falla por auth (token expirado), refrescar y reconectar
    s.on("connect_error", async (err) => {
      const isAuthError =
        err?.message?.toLowerCase().includes("invalid token") ||
        err?.message?.toLowerCase().includes("no token") ||
        err?.message?.toLowerCase().includes("401") ||
        err?.message?.toLowerCase().includes("unauthorized") ||
        err?.data?.type === "UnauthorizedError";

      if (!isAuthError || refreshingRef.current) return;

      refreshingRef.current = true;
      try {
        const newToken = await refreshAccessToken();
        s.auth = { token: newToken };
        s.disconnect().connect();
      } catch {
        // refresh falló → la sesión expiró, el logout lo maneja AuthContext
      } finally {
        refreshingRef.current = false;
      }
    });

    return () => {
      s.disconnect();
      socketRef.current = null;
      setSocket(null);
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, chatUnread, setChatUnread }}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
